import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-the-page-b01 c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-b01__body" }
const _hoisted_5 = { class: "p-the-page-b01__main" }
const _hoisted_6 = { class: "p-the-page-b01__header" }
const _hoisted_7 = { class: "p-the-page-b01__breadcrumb" }
const _hoisted_8 = { class: "p-the-page-b01__header__content" }
const _hoisted_9 = { class: "p-the-page-b01__header__content__info" }
const _hoisted_10 = { class: "p-the-page-b01__header__content__info__count" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "p-the-page-b01__item_list"
}
const _hoisted_14 = { class: "p-the-page-b01__item_list__nav" }
const _hoisted_15 = {
  key: 0,
  class: "p-the-page-b01__block"
}
const _hoisted_16 = { class: "p-the-page-b01__item_list" }
const _hoisted_17 = {
  key: 1,
  class: "p-the-page-b01__block"
}
const _hoisted_18 = { class: "p-the-page-b01__item_list" }
const _hoisted_19 = { class: "p-the-page-b01__item_list__btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheB01SearchPanel = _resolveComponent("TheB01SearchPanel")!
  const _component_TheSideMenu = _resolveComponent("TheSideMenu")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_TitleLarge = _resolveComponent("TitleLarge")!
  const _component_ButtonRefine = _resolveComponent("ButtonRefine")!
  const _component_ItemList = _resolveComponent("ItemList")!
  const _component_PageNavi = _resolveComponent("PageNavi")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_ItemListHeading = _resolveComponent("ItemListHeading")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TheSideMenu, {
            categories: _ctx.categories,
            onClickSubcategory: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clickOnSubcategory($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TheB01SearchPanel, {
                "search-from": _ctx.searchFrom,
                "onUpdate:searchFrom": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFrom) = $event)),
                "search-to": _ctx.searchTo,
                "onUpdate:searchTo": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTo) = $event)),
                "show-main-category-active": _ctx.showMainCategoryActive,
                "onUpdate:showMainCategoryActive": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showMainCategoryActive) = $event)),
                "current-category": _ctx.currentCategory,
                "current-category-child": _ctx.currentCategoryChild,
                "search-keyword": _ctx.searchKeyword,
                "is-usable-range": _ctx.isUsableRange,
                "max-point-searchable": _ctx.maxPointSearchable,
                onMinMaxForm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.minMaxfrom($event))),
                onClickSubcategoryUpper: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickOnUpperSubcategory($event)))
              }, null, 8, ["search-from", "search-to", "show-main-category-active", "current-category", "current-category-child", "search-keyword", "is-usable-range", "max-point-searchable"])
            ]),
            _: 1
          }, 8, ["categories"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_TheBreadcrumb)
              ]),
              _createVNode(_component_TitleLarge, { class: "p-the-page-b01__header__name" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pageTitle), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", null, "検索結果", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.haveItem)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.totaCountString) + "件(" + _toDisplayString(_ctx.count) + "件)", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, "0件"))
                  ])
                ]),
                (_ctx.haveItem)
                  ? (_openBlock(), _createBlock(_component_ButtonRefine, {
                      key: 0,
                      refine: _ctx.sorted.target,
                      "onUpdate:refine": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sorted.target) = $event)),
                      class: "p-the-page-b01__header__content__sort_btn",
                      heading: _ctx.heading,
                      icon: "sorted",
                      "refine-item-list": _ctx.sorted.itemList,
                      shown: _ctx.sorted.shownState,
                      width: '156px',
                      onDoSort: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doSort($event))),
                      onSwitchRefineState: _ctx.switchSortedState
                    }, null, 8, ["refine", "heading", "refine-item-list", "shown", "onSwitchRefineState"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.haveItem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_ItemList, {
                    items: _ctx.items,
                    "add-to-browser-history": true
                  }, null, 8, ["items"]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_PageNavi, {
                      "current-page": _ctx.currentPage,
                      "max-page": _ctx.maxPage,
                      "next-page-url": _ctx.nextPageUrl,
                      "prev-page-url": _ctx.prevPageUrl,
                      "base-url": _ctx.baseUrl
                    }, null, 8, ["current-page", "max-page", "next-page-url", "prev-page-url", "base-url"])
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_CommonHeading, {
                  key: 1,
                  class: "p-the-page-b01__empty"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createElementVNode("span", { class: "p-the-page-b01__empty__text" }, "ご指定の検索条件に該当する商品は", -1),
                    _createElementVNode("br", { class: "u-display-none--pc" }, null, -1),
                    _createElementVNode("span", { class: "p-the-page-b01__empty__text" }, "みつかりませんでした", -1)
                  ])),
                  _: 1,
                  __: [9]
                })),
            (!_ctx.haveItem)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.haveRecommendations)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_ItemListHeading, {
                          title: "おすすめの商品",
                          "title-en": "RECOMMENDED"
                        }),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ItemList, { items: _ctx.slicedRecommendations }, null, 8, ["items"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.haveHistories)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_ItemListHeading, {
                          title: "最近チェックした商品",
                          "title-en": "RECENTRY VIEWED"
                        }),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_ItemList, { items: _ctx.slicedHistories }, null, 8, ["items"])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_ButtonMain, {
                            tag: "a",
                            href: "/f01/",
                            kind: "secondary"
                          }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode("もっと見る", -1)
                            ])),
                            _: 1,
                            __: [10]
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_TheFooter)
    ])
  ]))
}